module.exports = __webpack_public_path__ + "img/美妆特效--实时美妆.94556554.png";